import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { titleize } from 'underscore.string';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import EditButton from 'components/v2/buttons/EditButton';
import { getClassName } from 'utils/ui/classes';
import Badge from 'components/v2/Badge';

class ShipmentDetailDateItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEdit: false,
      value: this.props.value,
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (!this.state.showEdit && newProps.value !== this.state.value) {
      this.setState({ value: newProps.value });
    }
  }

  handleSave() {
    if (this.props.param && this.props.useNamedUpdate) {
      return this.setState(
        { showEdit: false },
        this.props.onSave(this.props.param, this.state.value),
      );
    }
    this.setState({ showEdit: false }, this.props.onSave(this.state.value));
  }

  renderInlineEditing() {
    if (!this.state.showEdit) {
      return null;
    }
    const { t } = this.props;
    return (
      (<div data-testid="div-fc1a27c8" className="">
        <DatePicker
          key={0}
          selected={getMomentDate(this.state.value)}
          className="form-field"
          locale={this.props.locale}
          onChange={(value) => this.setState({ value })}
          placeholderText={t('SET_A_DATE')}
          isClearable
        />
        <div data-testid="div-8dac46bc" className="flex items-center mt-2 space-x-2">
          <button
            data-testid="button-ed2eaf43"
            key={2}
            onClick={() => this.handleSave()}
            className={`button button-green carrier-shipmentDetailDateItem-editAppointment heap ${this.props.heapClassName}`}>
            {titleize(t('SAVE'))}
          </button>
          <button
            data-testid="button-0ad88495"
            key={1}
            type="button button-gray"
            onClick={() => {
              this.setState({ showEdit: false, value: this.props.value });
            }}>
            {t('CANCEL')}
          </button>
        </div>
      </div>)
    );
  }

  renderBadge() {
    if (!this.props.badge) {
      return null;
    }
    const { badge, t } = this.props;
    let color = '';

    switch (badge) {
      case 'OPENTRACK':
        color = 'grey';
        break;
      case 'NOT_REPORTED':
        color = 'grey';
        break;
      default:
        color = 'green';
    }

    return (
      (<Badge dataTestId="Badge-278d9b60" color={color} size="small">
        {t(badge)}
      </Badge>)
    );
  }
  renderDate() {
    if (this.state.showEdit) {
      return null;
    }
    const { t } = this.props;
    return (
      (<div data-testid="div-977c0dbb" className="flex items-center space-x-2">
        <span data-testid="span-84c7a390" className="mb-0 mr-3 ">{formatDate(this.state.value, t)}</span>
        {this.props.editable && (
          <EditButton
            dataTestId="EditButton-a88b800a"
            title={t('EDIT_DATE')}
            disabled={!this.props.editable}
            onClick={() => this.setState({ showEdit: true })} />
        )}
      </div>)
    );
  }
  render() {
    const { dataTestId, title, titleClassName, className } = this.props;
    return (
      (<div
        data-testid={dataTestId}
        className={getClassName('mb-4', className)}>
        <div data-testid="div-45a9dd43" className="flex flex-row">
          <label data-testid="label-c42c4c01" className={getClassName("mb-1 space-x-1 form-label", titleClassName)}>
            {title}
          </label>
          {this.renderBadge()}
        </div>
        {this.renderDate()}
        {this.renderInlineEditing()}
      </div>)
    );
  }
}

ShipmentDetailDateItem.propTypes = {
  editable: PropTypes.bool,
  title: PropTypes.string,
  value: PropTypes.string,
  onSave: PropTypes.func,
  param: PropTypes.string,
  locale: PropTypes.string,
  useNamedUpdate: PropTypes.bool,
};

ShipmentDetailDateItem.defaultProps = {
  title: '',
  onSave: () => {},
  value: null,
  editable: false,
  param: '',
  useNamedUpdate: false,
};

function formatDate(date, t) {
  if (!date) {
    return t('NOT_SET');
  }

  return moment(date).format('L');
}

function getMomentDate(date) {
  if (!date) {
    return null;
  }
  return moment(date);
}

export default withTranslation()(ShipmentDetailDateItem);
